// node_modules
import React, { useState } from "react";
import { Button } from "primereact/button";
import { useNavigate } from "react-router";

import { DebtGraph } from "../../components/DebtGraph";

// styles
import * as styles from "./Graph.module.css";

const nodes = [
  {
    id: "A",
    position: { x: 120, y: 100 },
    data: { label: "АО НК «КазМунайГаз»" },
    sourcePosition: "right",
    targetPosition: "left",
  },
  {
    id: "B",
    position: { x: 380, y: 100 },
    data: { label: "АО «Kazatomprom»" },
    sourcePosition: "right",
    targetPosition: "left",
  },
  {
    id: "C",
    position: { x: 250, y: 300 },
    data: { label: "АО «Халык Банк Казахстана»" },
    sourcePosition: "left",
    targetPosition: "right",
  },
];

const edges = [
  {
    id: "A-B",
    source: "A",
    target: "B",
    label: "₸120m",
    animated: true,
    markerEnd: {
      type: "arrow",
    },
  },
  {
    id: "B-C",
    source: "B",
    target: "C",
    label: "₸95m",
    animated: true,
    markerEnd: {
      type: "arrow",
    },
  },
  {
    id: "C-A",
    source: "C",
    target: "A",
    label: "₸87m",
    animated: true,
    markerEnd: {
      type: "arrow",
    },
  },
];

const newNodes = [
  {
    id: "A",
    position: { x: 120, y: 100 },
    data: { label: "АО НК «КазМунайГаз»" },
    sourcePosition: "right",
    targetPosition: "left",
  },
  {
    id: "B",
    position: { x: 380, y: 100 },
    data: { label: "АО «Kazatomprom»" },
    sourcePosition: "right",
    targetPosition: "left",
  },
  {
    id: "C",
    position: { x: 250, y: 300 },
    data: { label: "АО «Халык Банк Казахстана»" },
    sourcePosition: "left",
    targetPosition: "right",
  },
];

const newEdges = [
  {
    id: "A-B",
    source: "A",
    target: "B",
    label: "₸33m",
    animated: true,
    markerEnd: {
      type: "arrow",
    },
  },
  {
    id: "B-C",
    source: "B",
    target: "C",
    label: "₸8m",
    animated: true,
    markerEnd: {
      type: "arrow",
    },
  },
];

export const Graph = () => {
  const navigate = useNavigate();

  const [newGraph, setNewGraph] = useState(false);

  return (
    <div className={styles.wrapper}>
      <div style={{ height: "90%", width: "100%" }}>
        <DebtGraph
          nodes={newGraph ? newNodes : nodes}
          edges={newGraph ? newEdges : edges}
        />
      </div>
      <div
        style={{
          width: "70%",
          display: "flex",
          justifyContent: "space-between",
          fontWeight: "800",
        }}
      >
        <Button
          className={styles.paginationBtn}
          onClick={() => (newGraph ? setNewGraph(false) : navigate("/table"))}
        >
          {"<"}
        </Button>
        <Button
          className={styles.paginationBtn}
          onClick={() => (newGraph ? navigate("/result") : setNewGraph(true))}
        >
          {">"}
        </Button>
      </div>
    </div>
  );
};
